export const siteMeta = {
  brand: '昨日吃瓜',
  tagline: '昨日瓜田 · 一页补全',
  intro:
    '把散落在各个平台的昨日热点、热搜与精华帖，按时点与话题梳理成一份好读的"昨日瓜报"。不追旧瓜，只为你补完昨天错过的那口瓜。',
  date: '9月8日 · 瓜报',
  keywords: ['昨日吃瓜', '昨日吃瓜热搜榜', '昨日瓜田大事件', '昨日吃瓜汇总', '昨日瓜田话题盘点'],
};

export const navLinks = [
  { id: 'today', label: '头条速览' },
  { id: 'timeline', label: '瓜田时间线' },
  { id: 'hot', label: '昨日热搜' },
  { id: 'topics', label: '话题分类' },
  { id: 'essence', label: '精华盘点' },
  { id: 'faq', label: '常见问答' },
];

export const heroLead = {
  kicker: '昨日头条',
  time: '更新于 昨晚 23:50',
  title: '一档新综艺首播即爆，相关话题两小时内冲上热搜前排',
  summary:
    '昨日晚间，一档主打熟人局与即兴互动的户外综艺开播，播出期间多个话题轮番登榜。节目环节设置、嘉宾化学反应与后期金句成为观众讨论的三大焦点。',
  tag: '综艺热点',
  heat: '讨论 12.8万',
};

export const heroSide = [
  {
    tag: '影视',
    title: '热播剧收官夜官宣"第二季"，主演群发手写信引爆催更',
    heat: '讨论 9.6万',
  },
  {
    tag: '品牌',
    title: '某品牌联名礼盒开售十分钟售罄，黄牛价翻了三倍引热议',
    heat: '讨论 7.2万',
  },
  {
    tag: '综艺',
    title: '音乐竞演节目公布导师阵容，三张"新面孔"成讨论焦点',
    heat: '讨论 6.5万',
  },
  {
    tag: '幕后',
    title: '纪录片团队晒幕后花絮，观众感慨"被低估的好内容"',
    heat: '讨论 4.8万',
  },
];

export const heroHighlights = [
  { icon: 'ri-fire-line', label: '单日热搜上榜', value: '47 次' },
  { icon: 'ri-question-answer-line', label: '昨日全网讨论', value: '186万+' },
  { icon: 'ri-file-list-3-line', label: '梳理话题', value: '63 条' },
];

export const timeline = [
  {
    slot: '早间 08:00–10:00',
    title: '首条热梗出圈',
    detail: '晨间一条节目片段被大量转发，"早起第一瓜"由此定调，早高峰时段相关阅读持续走高。',
    tone: '话题萌芽',
  },
  {
    slot: '上午 10:30',
    title: '热搜前排更替',
    detail: '两条影视动态先后登上热搜前十，红毯造型盘点帖开始集中出现，讨论以图文为主。',
    tone: '热度爬升',
  },
  {
    slot: '午间 12:00–14:00',
    title: '饭点话题井喷',
    detail: '午休时段多平台迎来讨论小高峰，综艺名场面、剧集剧情走向等话题在午间集中发酵。',
    tone: '讨论高峰',
  },
  {
    slot: '午后 15:00',
    title: '官方下场澄清',
    detail: '针对一则流传甚广的传闻，相关方发布说明，话题从"吃瓜"转向"求证"，热度不降反升。',
    tone: '反转求证',
  },
  {
    slot: '傍晚 18:00',
    title: '官宣消息落地',
    detail: '晚间黄金档前，多档节目与剧集集中发布物料与新预告，为晚间内容蓄势，预告播放量创新高。',
    tone: '物料潮',
  },
  {
    slot: '晚间 20:00–22:00',
    title: '首播即爆',
    detail: '新综艺首播期间多个话题轮番登榜，实时弹幕与二创内容同步爆发，成为昨日最大赢面。',
    tone: '热度顶峰',
  },
  {
    slot: '深夜 22:30 后',
    title: '二创长尾扩散',
    detail: '随着正片结束，混剪、表情包与解析帖接力，讨论从直播转向长尾内容，热度延续至深夜。',
    tone: '长尾发酵',
  },
];

export const hotRank = [
  {
    rank: 1,
    word: '#新综艺首播即爆#',
    type: '综艺',
    score: 9823,
    isLead: true,
  },
  {
    rank: 2,
    word: '#热播剧官宣第二季#',
    type: '影视',
    score: 9476,
  },
  {
    rank: 3,
    word: '#联名礼盒秒售罄#',
    type: '品牌',
    score: 8612,
  },
  {
    rank: 4,
    word: '#红毯造型盘点#',
    type: '时尚',
    score: 7934,
  },
  {
    rank: 5,
    word: '#音乐节目导师阵容#',
    type: '综艺',
    score: 7201,
  },
  {
    rank: 6,
    word: '#纪录片幕后花絮#',
    type: '幕后',
    score: 6548,
  },
  {
    rank: 7,
    word: '#剧组回应传闻#',
    type: '求证',
    score: 5889,
  },
  {
    rank: 8,
    word: '#老剧重播成情怀#',
    type: '怀旧',
    score: 5023,
  },
];

export const categories = [
  {
    icon: 'ri-movie-2-line',
    name: '影视剧综',
    desc: '新剧、老剧、综艺名场面一网打尽',
    count: '昨日 14 条',
  },
  {
    icon: 'ri-mic-2-line',
    name: '音乐演出',
    desc: '新歌、演出与音乐节目热点速递',
    count: '昨日 9 条',
  },
  {
    icon: 'ri-handbag-line',
    name: '时尚品牌',
    desc: '造型盘点与品牌联名风向观察',
    count: '昨日 11 条',
  },
  {
    icon: 'ri-group-line',
    name: '幕后故事',
    desc: '纪录片、幕后制作与从业者讲述',
    count: '昨日 6 条',
  },
  {
    icon: 'ri-scales-3-line',
    name: '求证专区',
    desc: '传闻核实、官方回应与时间线还原',
    count: '昨日 5 条',
  },
  {
    icon: 'ri-history-line',
    name: '怀旧情怀',
    desc: '老片重看与经典瞬间的集体记忆',
    count: '昨日 8 条',
  },
];

export const essencePosts = [
  {
    tag: '深度盘点',
    title: '昨日热搜的来龙去脉：从片段出圈到官方澄清的 8 小时',
    digest:
      '我们把昨日那条从热搜到求证再到落幕的完整链路捋了一遍，还原每个节点究竟发生了什么、讨论又是如何演变的。',
    meta: '复盘向 · 阅读 8 分钟',
    img: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20magazine%20collage%20of%20television%20variety%20show%20production%2C%20backstage%20lighting%20and%20screens%2C%20golden%20amber%20and%20cream%20tone%2C%20soft%20cinematic%20atmosphere%2C%20premium%20entertainment%20journalism%20visual&width=760&height=480&seq=essence-01&orientation=landscape',
  },
  {
    tag: '话题盘点',
    title: '一档新综艺首播后，网友都在讨论什么？',
    digest:
      '首播即爆的背后，是环节设置、嘉宾化学反应与后期剪辑的三重加成。我们整理了讨论区最高频的五个观点方向。',
    meta: '盘点向 · 阅读 6 分钟',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20outdoor%20variety%20show%20stage%20at%20dusk%2C%20people%20gathering%20under%20golden%20party%20lights%2C%20amber%20orange%20glow%2C%20joyful%20entertainment%20atmosphere%2C%20soft%20film%20grain%20editorial%20photography&width=760&height=480&seq=essence-02&orientation=landscape',
  },
  {
    tag: '幕后手记',
    title: '那些"看起来毫不费力"的名场面，幕后其实排练了多久',
    digest:
      '我们对话了几位幕后从业者，聊了聊综艺与影视中名场面的诞生过程，以及创作背后的取舍与反复。',
    meta: '访谈向 · 阅读 10 分钟',
    img: 'https://readdy.ai/api/search-image?query=Warm%20documentary%20style%20backstage%20scene%20of%20film%20crew%20and%20camera%20equipment%20under%20soft%20studio%20lighting%2C%20amber%20and%20cream%20palette%2C%20authentic%20cinema%20making%20behind%20the%20scenes%20editorial%20photo&width=760&height=480&seq=essence-03&orientation=landscape',
  },
];

export const aboutStats = [
  { value: '1800+', label: '篇瓜报梳理' },
  { value: '52 万', label: '追瓜用户' },
  { value: '日均', label: '更新 60+ 话题' },
  { value: '24h', label: '内完成求证' },
];

export const principles = [
  {
    icon: 'ri-time-line',
    title: '只做昨日',
    desc: '专注盘点刚过去 24 小时的话题，不追陈年旧账，让"补瓜"这件事轻量高效。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '先求证再表达',
    desc: '争议话题坚持还原时间线与多方口径，用"传闻/求证/结论"三层区分信息来源。',
  },
  {
    icon: 'ri-list-unordered',
    title: '结构化梳理',
    desc: '每个热点都按时点、角色与节点拆开讲，让你几分钟就能把来龙去脉看明白。',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '尊重不伤人',
    desc: '吃瓜也讲边界，涉及他人的内容以事实与善意为准，不做无端揣测与人格攻击。',
  },
];

export const testimonials = [
  {
    name: '早八地铁党',
    role: '通勤追瓜用户',
    text: '早上出门前刷一眼瓜报，通勤路上就能把昨晚上错过的梗补齐，和同事聊起来完全不掉队。',
    avatar: 'A',
  },
  {
    name: '午休冲浪选手',
    role: '讨论区常客',
    text: '最喜欢它的时间线，把一条热搜从出圈到澄清的过程讲得特别清楚，不用自己东拼西凑了。',
    avatar: 'B',
  },
  {
    name: '深夜补料人',
    role: '娱乐内容爱好者',
    text: '每晚睡前看一遍当天的瓜报已经成习惯，分类清楚、求证也认真，比在热搜上盲刷省心太多。',
    avatar: 'C',
  },
];

export const faqs = [
  {
    q: '「昨日吃瓜」是每天固定更新的吗？',
    a: '是的。我们按自然日为单位，在每个午夜过后发布"昨日瓜报"，把刚过去的 24 小时里散落在各平台的热点、热搜与精华帖集中盘点。遇到大型事件时会额外加更速报，确保你不错过关键节点。',
  },
  {
    q: '你们的内容来源是什么？是自己写的原创吗？',
    a: '瓜报以公开可见的节目物料、官方口径与平台公开讨论为信息来源，经过编辑部二次梳理、核实与结构化改写，属于原创的整理与盘点内容。我们在每篇盘点里都会标注讨论来源方向，方便你按图索骥去查看原帖。',
  },
  {
    q: '为什么叫「昨日」，是只关注娱乐圈吗？',
    a: '"昨日"指代"过去 24 小时内"这个时间窗口，代表我们只做新鲜、成体系的盘点，不做陈年旧瓜。内容方向不止娱乐圈，还包括综艺、影视、音乐、时尚品牌、幕后故事与公共话题等泛娱乐范畴，覆盖面更广。',
  },
  {
    q: '遇到有争议或反转的瓜，你们怎么处理？',
    a: '对任何存在争议的传闻，我们会坚持"先求证再表达"：先还原时间线，再并列多方口径，区分"传闻、求证、结论"三个层次呈现，避免在官方口径落地前下结论。若后续出现反转，会以速报形式及时更新说明。',
  },
  {
    q: '我也可以投稿或提供线索吗？',
    a: '非常欢迎。你可以在页尾订阅表单里留下线索方向，或通过底部邮箱与我们联系。我们更偏好可核实的公开信息（节目物料、官方发文、公开报道等），收到后会在工作日优先核实处理。',
  },
  {
    q: '想转载「昨日吃瓜」的内容，需要怎么做？',
    a: '个人用户请注明来源出处并保留原文链接即可；机构或商业平台的大篇幅转载，请先通过底部邮箱与我们取得授权，并保留署名与原始链接，我们会在授权范围内为你提供转载文案。',
  },
];

export const footerLinks = [
  {
    title: '内容栏目',
    items: [
      { label: '头条速览', href: '#today' },
      { label: '瓜田时间线', href: '#timeline' },
      { label: '昨日热搜', href: '#hot' },
      { label: '话题分类', href: '#topics' },
    ],
  },
  {
    title: '关于本站',
    items: [
      { label: '关于与口碑', href: '#about' },
      { label: '常见问答', href: '#faq' },
      { label: '内容原则', href: '#about' },
      { label: '订阅瓜报', href: '#subscribe' },
    ],
  },
];

export const siteContact = {
  email: 'hello@zuori-chigua.example',
  desc: '工作日 09:00–18:00 处理投稿、授权与合作来信',
};